import { ArgsType, Field, Int } from '@nestjs/graphql'
import { BaseGetArgs } from '../../base/baseGet.args'

@ArgsType()
export class MessagePostGetArgs extends BaseGetArgs<MessagePostGetArgs> {
  @Field(t => Int)
  threadId!: number

  @Field(t => Int, { nullable: true })
  state?: number

  @Field({ nullable: true })
  needle?: string
}
